import { create } from 'zustand';

export const useChatStore = create((set) => ({
    isOpen: false,
    conversationId: null,
    currentUserId: null,
    partner: null,
    messages: [],
    setMessages: (messages) => set({ messages }),
    addMessage: (message) => set((state) => ({ 
        messages: [...state.messages, message] 
    })),
    markMessagesAsRead: (readAt) => set((state) => ({
        messages: state.messages.map((msg) =>
            msg.sender_id !== state.currentUserId && !msg.read_at
                ? { ...msg, read_at: readAt }
                : msg
        ),
    })),
    markSentMessagesAsRead: (readAt) => set((state) => ({
        messages: state.messages.map((msg) =>
            msg.sender_id === state.currentUserId && !msg.read_at
                ? { ...msg, read_at: readAt }
                : msg
        ),
    })),
    setIsOpen: (isOpen) => set({ isOpen }),
    setConversationId: (id) => set({ conversationId: id }),
    setCurrentUserId: (id) => set({ currentUserId: id }),
    setPartner: (partner) => set({ partner }),
    closeChat: () => set({ isOpen: false, conversationId: null, messages: [], partner: null }),
}));
